import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
import IconButton from '../IconButton/IconButton';
var StyleIconButton = withProps()(styled(IconButton))(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ",
    ";\n"])), function (props) {
    return props.disabled
        ? props.theme.palette.action.disabled
        : props.theme.palette.text.secondary;
});
export default StyleIconButton;
var templateObject_1;
//# sourceMappingURL=StyledIconButton.js.map